
let language = {

    "PARTNER_VERIFY_URL_PARAM_MISSING": "网址参数缺失",
    
    "PARTNER_VERIFY_TOKEN_EXPIRE": "验证令牌过期。（请在 {{verifyTime}} 分钟内检查电子邮件）",
    "PARTNER_VERIFY_EMAIL_ALREADY_VERIFY": "电子邮件已验证",
    
    "PARTNER_VERIFY_SEND_EMAIL_SUCCESS": "发送邮件成功",
    
    "PARTNER_VERIFY_PARAM_MISSING": "缺少参数"
};

export { language }